import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNewspaper: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconNewspaper"><Path d="M7.5 8.5V11.5H11.5V8.5H7.5Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M2 3H17V11.25H22V17.75C22 19.5449 20.5449 21 18.75 21H5.25C3.45507 21 2 19.5449 2 17.75V3ZM18.75 19.5C19.7165 19.5 20.5 18.7165 20.5 17.75V12.75H17V17.75C17 18.7165 17.7835 19.5 18.75 19.5ZM6 15V16.5H13V15H6ZM6 7H13V13H6V7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconNewspaper;
